// Shared brand assets — self-hosted under /api/assets/brand on the same
// origin as REACT_APP_BACKEND_URL so they:
//   - bypass third-party CDN blocking (browser extensions / corp proxies)
//   - inherit Cloudflare caching from the gemslive.tv edge
//   - have ONE source of truth: when the URL changes, change THIS file only.
//
// Do NOT inline third-party CDN URLs anywhere in the React tree.
// Import BRAND_ASSETS.logo instead. A CI guard in
// /app/backend/tests/test_brand_assets_migration.py fails the build if any
// such URL re-appears in App.js or MarketingLandingPage.js.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const BRAND_ASSETS = {
  logo: `${BACKEND_URL}/api/assets/brand/gems_logo.png`,
  creatorsLive: `${BACKEND_URL}/api/assets/brand/creators_live.jpg`,
  spadesTable: `${BACKEND_URL}/api/assets/brand/spades_table.jpg`,
  connect4: `${BACKEND_URL}/api/assets/brand/connect4_game.png`,
};
